/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 10.07.25
 *
 */
import BaseObject from "@shared/BaseObject.js";
import {
	BOOK_EXPORT_DEFAULT_ORIENTATION_KEY,
	BOOK_EXPORT_DEFAULT_PAGE_SIZE_KEY,
	DEFAULT_FY_START_DAY,
	DEFAULT_FY_START_MONTH,
	FY_ANCHOR_YEAR,
	FY_SPLIT_ENABLED_KEY,
	FY_START_MS_KEY
} from "@shared/SharedConstants";
import {BookPageSizeEnum} from "@shared/BookWriting/BookPageSizeEnum";
import {BookOrientationEnum} from "@shared/BookWriting/BookOrientationEnum";

export default class DefaultValues extends BaseObject {

	defaultValues = {}

	constructor() {
		super();
	}

	getDefaultValue(valueType){
		return this.defaultValues[valueType] || null
	}
	setDefaultValue(valueType, value){
		this.defaultValues[valueType] = value || 0
	}

	getBillingOrgAddress(orgType){
		return this.defaultValues[`${orgType}_billingOrg_address`] || null
	}
	setBillingOrgAddress(orgType, value){
		this.defaultValues[`${orgType}_billingOrg_address`] = value
	}
	getBillingOrgEmail(orgType){
		return this.defaultValues[`${orgType}_billingOrg_email`] || null
	}
	setBillingOrgEmail(orgType, value){
		this.defaultValues[`${orgType}_billingOrg_email`] = value
	}

	getDefaultServiceValues(serviceType){
		return this.getDefaultValue(serviceType)
	}
	setDefaultServiceValues(serviceType, value){
		this.setDefaultValue(serviceType, value)
	}

	getFinancialYearStartMs(){
		return this.getDefaultValue(FY_START_MS_KEY)
	}
	getFinancialYearStartMsOrDefault(){
		return this.getFinancialYearStartMs()
			|| new Date(FY_ANCHOR_YEAR, DEFAULT_FY_START_MONTH - 1, DEFAULT_FY_START_DAY).getTime()
	}
	setFinancialYearStartMs(value){
		this.setDefaultValue(FY_START_MS_KEY, value)
	}
	getFinancialYearStartMonth(){
		let ms = this.getFinancialYearStartMs()
		return ms ? new Date(ms).getMonth() + 1 : null
	}
	setFinancialYearStartMonth(value){
		let month = Number(value)
		if(!month || month < 1 || month > 12){
			return
		}
		let ms = this.getFinancialYearStartMsOrDefault()
		let date = new Date(ms)
		date.setMonth(month - 1)
		this.setFinancialYearStartMs(date.getTime())
	}
	getFinancialYearStartDay(){
		let ms = this.getFinancialYearStartMs()
		return ms ? new Date(ms).getDate() : null
	}
	setFinancialYearStartDay(value){
		let day = Number(value)
		if(!day || day < 1 || day > 31){
			return
		}
		let ms = this.getFinancialYearStartMsOrDefault()
		let date = new Date(ms)
		date.setDate(day)
		this.setFinancialYearStartMs(date.getTime())
	}
	getFinancialYearSplitEnabled(){
		return this.getDefaultValue(FY_SPLIT_ENABLED_KEY)
	}
	setFinancialYearSplitEnabled(value){
		this.setDefaultValue(FY_SPLIT_ENABLED_KEY, value)
	}

	getBookExportDefaultPageSize(){
		return this.getDefaultValue(BOOK_EXPORT_DEFAULT_PAGE_SIZE_KEY) || BookPageSizeEnum.A4
	}

	setBookExportDefaultPageSize(value){
		this.setDefaultValue(BOOK_EXPORT_DEFAULT_PAGE_SIZE_KEY, value || BookPageSizeEnum.A4)
	}

	getBookExportDefaultOrientation(){
		return this.getDefaultValue(BOOK_EXPORT_DEFAULT_ORIENTATION_KEY) || BookOrientationEnum.PORTRAIT
	}

	setBookExportDefaultOrientation(value){
		this.setDefaultValue(BOOK_EXPORT_DEFAULT_ORIENTATION_KEY, value || BookOrientationEnum.PORTRAIT)
	}

	getBookExportDefaults(){
		return {
			pageSize: this.getBookExportDefaultPageSize(),
			orientation: this.getBookExportDefaultOrientation(),
		}
	}

	setBookExportDefaults(options = {}){
		this.setBookExportDefaultPageSize(options.pageSize)
		this.setBookExportDefaultOrientation(options.orientation)
	}


}
